import _ from 'lodash'
import WktFactory from 'legacy/libs/wicket'

function processPoints(geometry, callback, thisArg) {
  if (geometry instanceof google.maps.LatLng) {
    callback.call(thisArg, geometry)
  } else if (geometry instanceof google.maps.Data.Point) {
    callback.call(thisArg, geometry.get())
  } else {
    geometry.getArray().forEach((g) => processPoints(g, callback, thisArg))
  }
}

export function zoomMapToObj(map, obj) {
  if (_.isEmpty(obj)) {
    map.setZoom(1)
    return
  }

  const bounds = new google.maps.LatLngBounds()

  _.forEach(obj, (item) =>
    processPoints(item.getPaths(), bounds.extend, bounds)
  )
  map.fitBounds(bounds)
}

export function getOverlaysFromWkt(wkt, drawingConfig) {
  const Wkt = WktFactory()
  const wktInstance = new Wkt()

  try {
    if (!wkt) {
      throw Error('Empty wkt')
    }

    wktInstance.read(wkt)
  } catch (e) {
    return []
  }

  return wktInstance.toObject(drawingConfig)
}
